module.exports = __webpack_public_path__ + "img/venezuela.d42cc2f3.svg";